import { useEffect } from "react";
import {
    appendNextBusyClosesDemoRunEvent,
    shiftBusyClosesDemoViewers,
} from "./busyClosesDemoStore";

const RUN_EVENT_DELAY_MS = { min: 20_000, max: 40_000 };
const VIEWER_SHIFT_DELAY_MS = { min: 45_000, max: 90_000 };

const timeoutIds = new Set<number>();
let holderCount = 0;

/** Runs `tick` after a fresh random delay, forever, skipping ticks while the tab is hidden. */
const loop = ({
    delay,
    tick,
}: {
    delay: { min: number; max: number };
    tick: () => void;
}) => {
    const timeoutId = window.setTimeout(
        () => {
            timeoutIds.delete(timeoutId);
            if (document.visibilityState === "visible") {
                tick();
            }
            loop({ delay, tick });
        },
        delay.min + Math.random() * (delay.max - delay.min),
    );
    timeoutIds.add(timeoutId);
};

/** Starts the pacing for the first holder (a run event every 20 to 40 seconds, a viewer change every 45 to 90) and stops it after the last. */
const acquireTicker = () => {
    holderCount += 1;
    if (holderCount === 1) {
        loop({
            delay: RUN_EVENT_DELAY_MS,
            tick: () =>
                appendNextBusyClosesDemoRunEvent({
                    now: Date.now(),
                    random: Math.random,
                }),
        });
        loop({
            delay: VIEWER_SHIFT_DELAY_MS,
            tick: () => shiftBusyClosesDemoViewers({ random: Math.random }),
        });
    }
    return () => {
        holderCount -= 1;
        if (holderCount === 0) {
            timeoutIds.forEach((timeoutId) => window.clearTimeout(timeoutId));
            timeoutIds.clear();
        }
    };
};

/** Keeps the shared ticker running while any page using the demo is mounted with the mode on. */
export const useBusyClosesDemoTicker = (isOn: boolean) => {
    useEffect(() => (isOn ? acquireTicker() : undefined), [isOn]);
};
